import {connect} from '../../../app/connect';
import {getIssueRootCausesDefinitionsEntitiesMap, getIssueRootCausesCategoriesIds} from '../../../app/selectors';
import {toggleTitleEditedIssueRootCauseAction} from '../../../app/actions';
import IssueRootCausesAdminTable from './IssueRootCausesAdminTable';

const mapStateToProps = state => ({
  data: getIssueRootCausesDefinitionsEntitiesMap(state),
  issueRootCauseCategoriesIds: getIssueRootCausesCategoriesIds(state)
});

const mapDispatchToProps = {
  toggleTitleEditedIssueRootCauseAction
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IssueRootCausesAdminTable);
